export const getRole = user => user && user.role
